import { useEffect, useState } from "react";
import { ReactComponent as Check } from "../../../../assets/icons/check.svg";
import { ChatInfo } from "../../../../core/auth/chatSlice";
import { ChatApiRoutes } from "../../../../shared/api-routes/chat.api-routes";
import http from "../../../../shared/utils/http";
import Button from "../../../essentials/button/Button";
import ClickIcon from "../../../essentials/icon-buttons/click-icon/ClickIcon";
import AcedModal from "../../../essentials/modals/aced-modal/AcedModal";
import UserCard from "../../../essentials/user-card/UserCard";
import "./SendButton.scss";

export interface SendButtonProps {
	title: string;
	color?: string;
	disabled?: boolean;
	onSend: (selected: string[]) => Promise<void>;
}
export const SendButton: React.FC<SendButtonProps> = ({
	title,
	color,
	disabled = false,
	onSend,
}) => {
	const [isModalOpen, setModalOpen] = useState<boolean>(false);
	const [chats, setChats] = useState<ChatInfo[]>([]);
	useEffect(() => {
		if (isModalOpen) {
			http.get(ChatApiRoutes.GET_ALL_CHATS).then((response: any) => {
				// Handle both array and object responses
				const rawChats = response?.chats || (Array.isArray(response) ? response : []);
				// Map backend response to ChatInfo format
				const chatList = rawChats.map((chat: any) => ({
					...chat,
					other: chat.otherParticipant || chat.other
				}));
				setChats(chatList);
			});
		} else setSelected([]);
	}, [isModalOpen]);

	const [selected, setSelected] = useState<string[]>([]);

	const toggleSelected = (selectedChat: string) => {
		if (selected.includes(selectedChat))
			setSelected((prev) => prev.filter((index) => index !== selectedChat));
		else setSelected((prev) => [...prev, selectedChat]);
	};

	const handleSend = async () => {
		await onSend(selected);
		setModalOpen(false);
	};
	return (
		<>
			<ClickIcon
				icon="send"
				color={color}
				tooltip="Send"
				onClick={
					disabled
						? undefined
						: () => {
								setModalOpen(true);
						  }
				}
				className={disabled ? "disabled" : ""}
			/>
			{isModalOpen && (
				<AcedModal
					state={{ isModalOpen, setModalOpen }}
					title={title}
				>
					<div className="send-modal-content">
						<div className="chat-list">
							{chats.map((chat) => (
								<div
									key={chat.id}
									className={`chat-item ${
										selected.includes(chat.id) ? "selected" : ""
									}`}
									onClick={() => toggleSelected(chat.id)}
								>
									<UserCard
										userInfo={chat.other}
										size="s"
										darkMode={false}
										onClick={() => toggleSelected(chat.id)}
									/>
									{selected.includes(chat.id) && (
										<div className="send-button-select-check">
											<Check
												style={{
													stroke: "white",
													width: "15px",
													height: "15px",
													strokeWidth: 5,
												}}
											/>
										</div>
									)}
								</div>
							))}
						</div>
						<div className="send-button-footer">
							<Button
								className="btn btn-primary"
								action={handleSend}
							>
								Send
							</Button>
						</div>
					</div>
				</AcedModal>
			)}
		</>
	);
};
